<template>
  <v-row>
    <v-col cols="12" :md="8" :sm="7">
      <template v-if="!isWriteReview">
        <PageTitle
          :title="titlePage"
          :onlyHeader="true"
        >
          <v-btn
            depressed
            color="primary"
            class="text-none font-weight-bold ml-md-auto mb-md-3 subtitle-2 mt-3"
            @click="writeReview"
          >
            <v-icon size="18" class="mr-2">fal fa-pen-to-square</v-icon>
            <translate>Write a Review</translate>
          </v-btn>
        </PageTitle>
        <v-row class="d-flex align-stretch mb-2">
          <v-col cols="12" :lg="7" :md="12" v-if="isTotalReview">
            <v-card class="py-md-6 px-md-10 pa-4" style="height: 100%">
              <div class="total-review">
                <div class="total-review__block d-flex">
                  <div class="total-review__score mr-4">
                    <strong>{{ courseReviewTotal.overallRating }}</strong>
                  </div>
                  <div class="total-review__rating">
                    <p class="text-h6 mb-0 pt-2">
                      {{ nameRating(courseReviewTotal.overallRating) }}
                    </p>
                    <div
                      class="d-flex flex-wrap justify-space-between align-center"
                    >
                      <v-rating
                        empty-icon="fas fa-star"
                        full-icon="fas fa-star"
                        half-icon="fas fa-star-half"
                        background-color="#C4C4C4"
                        color="#F2C94C"
                        length="5"
                        size="15"
                        :ripple="false"
                        :value="courseReviewTotal.overallRating"
                        readonly
                        class="mr-3"
                      ></v-rating>
                      <span class="grey--text subtitle-2"
                        >{{ courseReviewTotal.totalReview }}
                        <translate>reviews</translate>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="total-review__chart mt-5">
                  <template
                    v-for="(item, index) in courseReviewTotal.reviewData"
                  >
                    <ChartLine
                      v-if="index != 'overall'"
                      :name="reviewKey[index]"
                      :value="item"
                      :key="index"
                    />
                  </template>
                </div>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" :lg="isTotalReview ? 5 : 12" :md="12">
            <LangCard
              column
              style="height: 100%"
              :totalAll="99"
              :items="langList"
              @change="onChange"
            />
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12">
            <div class="wrapperBox">
              <div v-if="posts.length === 0">
                <span class="mr-1 font-weight-bold">{{courseDetail.name}}</span>
                {{showTextNoPost()}}
              </div>
              <template v-else>
                <Post
                  v-for="(item, key) in posts"
                  :item="item"
                  :key="key"
                  @onData="onData"
                >
                  <PostRating :reviewData="item.reviewData" readonly />
                </Post>
              </template>

              <InfiniteLoad
                v-if="reLoad"
                @loading="onLoadPost"
                :disabled="endData"
                :pageBegin="pageBegin"
              />
            </div>
          </v-col>
        </v-row>
      </template>

      <CoursesWriteReview
        :item="itemReview"
        v-else
        @onHideWriteReview="writeReview"
        @reloadReviewData="doReloadReviewData"
      />
    </v-col>
    <v-col cols="12" :md="4" :sm="5">
      <DrawerRight />
    </v-col>
  </v-row>
</template>

<script>
import { mergeByKey } from "@/utils/helper";
import { mapState } from "vuex";
import DrawerRight from "@/components/DrawerRight";
import PageTitle from "@/components/PageTitle";

import ChartLine from "@/components/Courses/ChartLine";
import PostRating from "@/components/Post/PostRating";
import CoursesWriteReview from "@/components/Courses/CoursesWriteReview";

import Post from "@/components/Post/Post";

import InfiniteLoad from "@/components/InfiniteLoad/InfiniteLoad";

import LangCard from "@/components/Card/LangCard";

export default {
  props: {
    isCourseAdmin: { type: Boolean, default: false },
  },
  name: "CoursesReview",
  metaInfo() {
    return {
      title: this.metaTitle,
      titleTemplate: null,
      meta: [
        {
          name: "description",
          content: this.metaDescription,
          vmid: 'description'
        },
      ],
    };
  },
  components: {
    DrawerRight,
    PageTitle,
    CoursesWriteReview,
    Post,
    PostRating,
    ChartLine,
    InfiniteLoad,
    LangCard,
  },
  data() {
    return {
      langList: [],
      lang: 0, //all
      pageBegin: 0,
      endData: false,
      reLoad: true, //for infinity
      reviewKey: {
        value: this.$gettext("Value for money"),
        clubhouse: this.$gettext("Clubhouse"),
        facilities: this.$gettext("Facilities"),
        maintenance: this.$gettext("Course maintenance"),
        surroundings: this.$gettext("Surroundings"),
      },
      radioGroup: 1,
      isWriteReview: false,
      courseReviewTotal: {},
      posts: [],
      itemReview: {},
    };
  },
  computed: {
    ...mapState({
      token: (state) => state.auth.token,
      courseDetail: (state) => state.golfcourse.courseDetail,
    }),
    isTotalReview() {
      return this.courseReviewTotal && this.courseReviewTotal.overallRating;
    },
    metaTitle() {
      return this.$gettextInterpolate(this.$gettext("%{courseName} - Golf Courses Reviews"), {
        courseName: (this.courseDetail && this.courseDetail.name) || "",
      });
    },
    metaDescription() {
      const binder = {
          courseName: (this.courseDetail && this.courseDetail.name) || "",
          countryName:
            (this.courseDetail && this.courseDetail.country.name) || "",
      }
      const translated = this.$gettext("Reviews of %{courseName} golf courses  in %{countryName}, Discover %{courseName} reviews of Golf courses. Check all the Golf courses reviews at %{courseName}");
      return this.$gettextInterpolate(translated, binder)
    },
    currentPost() {
      return this.$store.state.post.currentPost;
    },
    titlePage() {
      return this.$gettextInterpolate(this.$gettext('Latest reviews %{name}'), {name: this.courseDetail.name})
    }
  },
  watch: {
    courseDetail: {
      immediate: true,
      handler(val) {
        this.itemReview.course = val.id;
      },
    },
    currentPost(val) {
      if (val && val.id) {
        this.itemReview = {
          id: val.id,
          language: val.language,
          course: val.course.id,
          content: val.content,
          type: val.type,
          reviewData: val.reviewData,
        };
        this.isWriteReview = true;
      }
    },
  },
  beforeDestroy() {
    this.$store.commit("setCourseDetail", {});
    this.$store.commit("setCourseReviewTotal", {});
  },
  methods: {
    showTextNoPost() {
      const text = this.$gettext("has not any reviews yet.")
      return text
    },
    // create , update, delete
    async onData(item) {
      let i = this.posts.findIndex((x) => x.id == item.id);
      if (item.mode === "create") {
        delete item.mode;
        this.posts.splice(0, 0, item); //unshift
      } else if (item.mode === "update") {
        delete item.mode;
        const updated = { ...this.posts[i], ...item };
        this.$set(this.posts, i, updated);
      } else {
        this.posts.splice(i, 1);
      }
      await this.getData();
      await this.onChange();
      return;
    },
    async getData() {
      const item = this.courseDetail;
      if (item.id) {
        const result = await this.$store.dispatch("getCourseReviewTotal", item.id);
        if (!result.error) {
          this.courseReviewTotal = result;
        }
        this.langList = result.languages.sort((a, b) =>
          b.count - a.count
        );
      }
    },
    nameRating(val) {
      if (val >= 4.5)            return this.$gettext("Amazing");
      if (val >= 4 && val < 4.5) return this.$gettext("Great");
      if (val >= 3.5 && val < 4) return this.$gettext("Very Good");
      if (val >= 3 && val < 3.5) return this.$gettext("Good");
      if (val >= 2.5 && val < 3) return this.$gettext("Average");
      if (val >= 2 && val < 2.5) return this.$gettext("Poor");
      return this.$gettext("Very poor");
    },
    async writeReview() {
      if (this.token) {
        this.itemReview = {
          course: this.courseDetail.id,
        };
        this.isWriteReview = !this.isWriteReview;
      } else {
        const toggle = await this.$store.state.toggle.dialogConfirm.open(
          this.$gettext("Warning"),
          this.$gettext('You need to login'),
          { color: "warning" }
        );
        if (!toggle) return
        this.$router.push({name: 'login'})
      }
    },
    async onLoadPost(page) {
      let item = this.courseDetail;
      if (item.id) {
        let result = await this.$store.dispatch("getCourseReview", {
          id: item.id,
          page: ++this.pageBegin,
          lang: this.lang,
        });
        if (result.error || !result.list.length) {
          this.endData = true;
        } else {
          this.posts = mergeByKey(this.posts, result.list, "id");
        }
      }
    },
    onChange(val = null) {
      this.posts = [];
      this.reLoad = false;
      this.$nextTick(() => {
        this.reLoad = true;
        if(val) {
          this.lang = val;
        }
        this.pageBegin = 0;
        this.endData = false;
      });
    },
    async doReloadReviewData() {
      this.isWriteReview = false;
      await this.getData();
      await this.onChange();
    }
  },
  async mounted() {
    await this.getData();
  },
};
</script>
